import { Col, ControlLabel, FormGroup, Row } from "react-bootstrap";

import Button from "../../../elements/CustomButton/CustomButton.jsx";
import CurrencyInput from "../../Currency/CurrencyInput";
import { FIXED2 } from "../../../tools/fixedTools";
import { FormattedMessage } from "react-intl";
import React from "react";
import Spinner from "../../../elements/Spinner/Spinner";
import { TTC2HT } from "../../../tools/ttcConversion";
import TaxSelect from "../../Tax/TaxSelect";

const ExpenseFormTaxLine = ({
  index, //taxPieceIndex
  lineIndex,
  taxPiece,
  editMode,
  currencyId,
  onChange,
  removeTaxLine,
  companyId,
  totalTTC
}) => {
  // console.log("23 - ExpenseFormTaxLine tax:", taxPiece);
  if (!taxPiece) return <Spinner size="lg" fullScreen />;

  return (
    <div>
      <Row>
        <Col xs={0} sm={1} />
        <Col xs={0} sm={2} className="text-center">
          <FormGroup>
            {index === 0 ? <ControlLabel /> : <div />}
            <FormattedMessage id="ids_dontTaxe" />
          </FormGroup>
        </Col>
        <Col xs={6} sm={4} className="padding-right-0">
          <FormGroup validationState={taxPiece.validation && taxPiece.validation.taxIdValidation}>
            {index === 0 ? (
              <ControlLabel>
                <FormattedMessage id="ids_tax" />
              </ControlLabel>
            ) : (
                <div />
              )}
            <TaxSelect
              creatable
              // forbiddenLabels={tax1ForbiddenLabels}
              // sendNotification={sendNotification}
              companyId={companyId}
              showDefaultCheckBox={false}
              value={taxPiece.tax}
              onSelected={e => {
                if (!!!e || !!!e.element) {
                  return onChange(
                    {
                      ...taxPiece,
                      label: "",
                      taux: 0,
                      // tax: e && e.element.id,
                      tax: {
                        id: null,
                        taux: 0,
                        label: ""
                      },
                      amount: 0
                    },
                    index,
                    lineIndex
                  );
                }

                // if( withIdemCheckBox && taxIdemCompany){
                //   onChange('taxIdemCompany', false)
                // }
                // setForbiddenLabels([ e && e.element.label, tax2 && tax2.label ])
                // console.log("e", e);
                const ht = TTC2HT(FIXED2(totalTTC), e.element.valuePourcent);
                console.log("HT =", ht);

                return onChange(
                  {
                    ...taxPiece,
                    label: e && e.label,
                    taux: (e && e.element.valuePourcent) || 0,
                    // tax: e && e.element.id,
                    tax: {
                      id: e && e.element.id,
                      taux: e && e.element.valuePourcent,
                      label: e && e.label
                    },
                    amount:
                      (e &&
                        FIXED2(
                          (e.element.valuePourcent * Math.abs(ht)) / 100
                        )) ||
                      0
                  },
                  index,
                  lineIndex
                );
              }}
            />
          </FormGroup>
        </Col>
        <Col className="padding-right-0" xs={3} sm={3}>
          <FormGroup validationState={taxPiece.validation && taxPiece.validation.taxAmountValidation}>
            {index === 0 ? (
              <ControlLabel>
                <FormattedMessage id="ids_sumDeductible" />
              </ControlLabel>
            ) : (
                <div />
              )}
            <CurrencyInput
              disabled={!editMode}
              currencyId={currencyId}
              value={taxPiece.amount}
              update={event => {
                console.log("event", event);
                return onChange(
                  { ...taxPiece, amount: event.value },
                  index,
                  lineIndex
                );
              }}
            />
          </FormGroup>
          {index === 0 ? (
            <Button
              disabled={!editMode}
              onClick={() => removeTaxLine(index, lineIndex)}
              style={{ position: "absolute", top: "48px", right: "-28px" }}
              chip>
              <i style={{ width: "17px" }} className="fa fa-trash" />
            </Button>
          ) : (
              <Button
                disabled={!editMode}
                onClick={() => removeTaxLine(index, lineIndex)}
                style={{ position: "absolute", top: "10px", right: "-28px" }}
                chip>
                <i style={{ width: "17px" }} className="fa fa-trash" />
              </Button>
            )}
        </Col>
      </Row>
    </div>
  );
};

export default ExpenseFormTaxLine;
